export const AUTH_TOKEN = 'auth-token';
export const AUTH_USER = 'auth-user';
